import React from 'react'
import '../style/pageNav.scss'

class PageNav extends React.Component {
  constructor(props) {
    super();
    this.state = {
      activePage: 0
    }
  }

  handlePageScroll = (e) => {
    var topArr = [0, 900, 1600, 2600, 3600];
    const index = Number(e.currentTarget.dataset.index);
    if (index !== this.state.activePage) {
      window.$('html,body').animate({
        scrollTop: topArr[index]
      }, 1000);
    }

    this.setState({ activePage: index });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.scrollTop !== this.props.scrollTop) {
      let index = 0;
      const scrollTop = this.props.scrollTop;
      if (scrollTop >= 700 && scrollTop < 1600) {
        index = 1;
      } else if (scrollTop >= 1600 && scrollTop < 2600) {
        index = 2;
      } else if (scrollTop >= 2600 && scrollTop < 3600) {
        index = 3;
      } else if (scrollTop >= 3600) {
        index = 4;
      }
      this.setState({ activePage: index })
    }
  }

  render() {
    return (
      <div className={`page-nav ${this.props.scrollTop > 500 ? 'active' : ''}`}>
        <div className="weibo"><a href="https://weibo.com/3861707642/Jqux30xh1?from=page_1006063861707642_profile&wvr=6&mod=weibotime&type=comment#_rnd1603420608956" target="_blank"></a></div>
        <ul>
          {[1, 2, 3, 4].map(num => (
            <li className={num === this.state.activePage ? 'active' : ''} key={num.toString()} data-index={num.toString()} onClick={this.handlePageScroll}>
              <div className="normal"></div>
              <div className="active"></div>
            </li>
          ))}
        </ul>
        <div data-index="0" className="top" onClick={this.handlePageScroll}></div>
      </div>
    )
  }
}
export default PageNav;
